export const translate = key => window.__litium.translation[key] || key;
export const convertFirstLetterCaps = key => key.toLowerCase().replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase());